import Switcher from 'components/forms/Switcher/Switcher';

export default Switcher;
